// extracted by mini-css-extract-plugin
module.exports = {"History":"history_History__hhd_n","hero":"history_hero__iM3Qr","quote":"history_quote__PWfqS","author":"history_author__NgXOc"};